import React from 'react';
import { AnyObject } from '@triare/auth-redux';

/* eslint-disable max-len */

interface Svg extends React.SVGProps<SVGSVGElement> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export type IconProps = React.HTMLAttributes<SVGElement> & AnyObject;

export function Svg({
  children,
  className = '',
  viewBox = '0 0 24 24',
  style = {},
  ...props
}: Svg): React.ReactNode {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      height="1em"
      width="1em"
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
    >
      {children}
    </svg>
  );
}

export function MainLogo(props: IconProps) {
  return (
    <svg
      width="160"
      height="88" // "88"
      viewBox="0 0 160 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11005_1252)">
        <g clipPath="url(#clip1_11005_1252)">
          <path
            d="M33.2385 25.5892H39.1668L39.5712 29.2688H39.8733C41.1399 26.749 43.824 25.287 47.1703 25.287C47.7258 25.287 48.388 25.3359 48.9434 25.4381V32.2907C48.2857 32.1884 47.7791 32.1884 47.1214 32.1884C42.5619 32.1884 40.0289 35.1126 40.0289 40.2009V50.9819H33.2385V25.5892Z"
            fill="#FF380E"
          />
          <path
            d="M51.8854 41.6096V25.5892H58.6757V40.352C58.6757 43.6272 60.4978 45.5914 63.3863 45.5914C66.426 45.5914 68.4035 43.325 68.4035 39.9965V25.5892H75.1939V50.9864H69.2657L68.9635 48.2667H68.6613C67.0926 50.382 64.7595 51.5907 61.6176 51.5907C55.9916 51.5907 51.8898 47.6623 51.8898 41.6141L51.8854 41.6096Z"
            fill="#FF380E"
          />
          <path
            d="M79.9534 41.6096V25.5892H86.7437V40.352C86.7437 43.6272 88.5657 45.5914 91.4543 45.5914C94.494 45.5914 96.4715 43.325 96.4715 39.9965V25.5892H103.262V50.9864H97.3337L97.0315 48.2667H96.7293C95.1606 50.382 92.8275 51.5907 89.6856 51.5907C84.0596 51.5907 79.9578 47.6623 79.9578 41.6141L79.9534 41.6096Z"
            fill="#FF380E"
          />
          <path
            d="M108.026 41.6096V25.5892H114.816V40.352C114.816 43.6272 116.638 45.5914 119.527 45.5914C122.566 45.5914 124.544 43.325 124.544 39.9965V25.5892H131.334V50.9864H125.406L125.104 48.2667H124.802C123.233 50.382 120.9 51.5907 117.758 51.5907C112.132 51.5907 108.03 47.6623 108.03 41.6141L108.026 41.6096Z"
            fill="#FF380E"
          />
          <path
            d="M148.155 31.0286C144.964 31.0286 142.884 33.295 142.884 36.8724V50.9819H136.094V25.5892H142.022L142.324 28.3089H142.626C144.146 26.2424 146.83 24.9848 150.123 24.9848C156.052 24.9848 159.9 28.9666 159.9 35.2148V50.9864H153.11V36.5746C153.11 33.0995 151.234 31.033 148.146 31.033L148.155 31.0286Z"
            fill="#FF380E"
          />
          <path
            d="M27.4969 52.3551C24.4751 49.311 20.4399 47.6401 16.1338 47.6401C14.0495 47.6401 12.0631 48.0356 10.2322 48.7555C9.41451 48.56 8.65459 48.1467 8.41018 47.4134C8.0591 46.3602 8.21909 45.5025 10.0811 44.4671C10.0944 44.4582 10.1078 44.4538 10.1211 44.4449C11.9298 45.3426 13.9385 45.8092 16.0182 45.8092C23.3907 45.8092 29.4167 39.8454 29.4567 32.5129C29.4745 28.9666 28.1102 25.6292 25.6038 23.1095C23.0841 20.5764 19.72 19.1766 16.1249 19.1766C8.75236 19.1766 2.72636 25.1404 2.69081 32.4729C2.67304 35.5259 3.68626 38.4233 5.57049 40.7786C3.71292 42.4051 2.06422 44.5604 2.27753 47.9645C2.39751 49.9154 3.02411 51.5641 4.17954 52.9417C1.61093 55.777 0.042218 59.501 0.0199983 63.5894C-0.00222148 67.8378 1.6376 71.8418 4.63726 74.8593C7.66359 77.8989 11.6987 79.5699 16.0049 79.5699C24.8439 79.5699 32.0742 72.4195 32.1187 63.625C32.1409 59.3766 30.5011 55.3726 27.4969 52.3596V52.3551ZM16.1204 25.5048C18.018 25.5048 19.7911 26.238 21.1154 27.5712C22.4264 28.8866 23.1374 30.6331 23.1285 32.4818C23.1108 36.348 19.92 39.4899 16.0138 39.4899C14.1207 39.4899 12.3431 38.7566 11.0188 37.4234C9.71225 36.1036 8.99678 34.3616 9.01011 32.5129C9.02789 28.6466 12.2186 25.5048 16.1204 25.5048ZM16.0049 72.464C13.6052 72.464 11.3521 71.5352 9.67226 69.8465C8.01911 68.1845 7.11254 65.9714 7.12588 63.625C7.1481 58.7277 11.1876 54.7504 16.1338 54.7504C18.5335 54.7504 20.7821 55.6792 22.4619 57.3679C24.1195 59.0344 25.0261 61.243 25.0128 63.5894C24.9861 68.4866 20.9466 72.464 16.0049 72.464Z"
            fill="#FF380E"
          />
          <path
            d="M58.6758 17.0701C60.5511 17.0701 62.0709 18.5811 62.0709 20.4475C62.0709 22.314 60.5511 23.8738 58.6758 23.8738C56.8004 23.8738 55.2317 22.3629 55.2317 20.4475C55.2317 18.5322 56.8004 17.0701 58.6758 17.0701Z"
            fill="#FF380E"
          />
          <path
            d="M68.4035 17.0701C70.2256 17.0701 71.7987 18.5811 71.7987 20.4475C71.7987 22.314 70.23 23.8738 68.4035 23.8738C66.4793 23.8738 64.9595 22.3629 64.9595 20.4475C64.9595 18.5322 66.4793 17.0701 68.4035 17.0701Z"
            fill="#FF380E"
          />
          <path
            d="M86.7436 17.0701C88.619 17.0701 90.1388 18.5811 90.1388 20.4475C90.1388 22.314 88.619 23.8738 86.7436 23.8738C84.8683 23.8738 83.2996 22.3629 83.2996 20.4475C83.2996 18.5322 84.8683 17.0701 86.7436 17.0701Z"
            fill="#FF380E"
          />
          <path
            d="M96.4715 17.0701C98.2935 17.0701 99.8667 18.5811 99.8667 20.4475C99.8667 22.314 98.298 23.8738 96.4715 23.8738C94.5473 23.8738 93.0275 22.3629 93.0275 20.4475C93.0275 18.5322 94.5473 17.0701 96.4715 17.0701Z"
            fill="#FF380E"
          />
          <path
            d="M114.816 17.0701C116.691 17.0701 118.211 18.5811 118.211 20.4475C118.211 22.314 116.691 23.8738 114.816 23.8738C112.941 23.8738 111.372 22.3629 111.372 20.4475C111.372 18.5322 112.941 17.0701 114.816 17.0701Z"
            fill="#FF380E"
          />
          <path
            d="M124.544 17.0701C126.366 17.0701 127.939 18.5811 127.939 20.4475C127.939 22.314 126.37 23.8738 124.544 23.8738C122.62 23.8738 121.1 22.3629 121.1 20.4475C121.1 18.5322 122.62 17.0701 124.544 17.0701Z"
            fill="#FF380E"
          />
          <path
            d="M30.1411 17.0701C32.0164 17.0701 33.5363 18.5811 33.5363 20.4475C33.5363 22.314 32.0164 23.8738 30.1411 23.8738C28.2657 23.8738 26.697 22.3629 26.697 20.4475C26.697 18.5322 28.2657 17.0701 30.1411 17.0701Z"
            fill="#FF380E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11005_1252">
          <rect width="160" height="88" fill="white" />
        </clipPath>
        <clipPath id="clip1_11005_1252">
          <rect
            width="160"
            height="62.4997"
            fill="white"
            transform="translate(0.0200195 17.0701)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconDockToLeft(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask id="mask0_599_9869" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_599_9869)">
        <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" />
      </g>
    </Svg>
  );
}

export function IconDockToRight(props: Partial<Svg>) {
  return (
    <IconDockToLeft {...props} style={{ transform: 'scale(-1, 1)', ...(props?.style || {}) }} />
  );
}

export function IconNotificationOff(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> */}
      <mask id="mask0_1004_8935" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1004_8935)">
        <path
          d="M4.00002 19V17H6.00002V10C6.00002 9.45 6.07086 8.90833 6.21252 8.375C6.35419 7.84167 6.56669 7.33333 6.85002 6.85L8.35003 8.35C8.23336 8.61667 8.14586 8.8875 8.08752 9.1625C8.02919 9.4375 8.00002 9.71667 8.00002 10V17H14.2L1.40002 4.2L2.80002 2.8L21.2 21.2L19.8 22.6L16.15 19H4.00002ZM18 15.15L16 13.15V10C16 8.9 15.6084 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C11.5667 6 11.15 6.06667 10.75 6.2C10.35 6.33333 9.98336 6.53333 9.65003 6.8L8.20003 5.35C8.53336 5.08333 8.89169 4.85 9.27502 4.65C9.65836 4.45 10.0667 4.3 10.5 4.2V3.5C10.5 3.08333 10.6459 2.72917 10.9375 2.4375C11.2292 2.14583 11.5834 2 12 2C12.4167 2 12.7709 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8334 4.53333 15.9167 5.2375 16.75 6.3125C17.5834 7.3875 18 8.61667 18 10V15.15ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1959 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0209 21.8042 12.55 22 12 22Z"
          fill="currentColor" // #555555
        />
      </g>
      {/* </svg> */}

    </Svg>
  );
}
export function IconFrontHand(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1004_8940"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1004_8940)">
        <path
          d="M12 12V2C12 1.71667 12.0958 1.47917 12.2875 1.2875C12.4792 1.09583 12.7167 1 13 1C13.2833 1 13.5208 1.09583 13.7125 1.2875C13.9042 1.47917 14 1.71667 14 2V12H12ZM8 12V3C8 2.71667 8.09583 2.47917 8.2875 2.2875C8.47917 2.09583 8.71667 2 9 2C9.28333 2 9.52083 2.09583 9.7125 2.2875C9.90417 2.47917 10 2.71667 10 3V12H8ZM12.5 23C10.1333 23 8.125 22.175 6.475 20.525C4.825 18.875 4 16.8667 4 14.5V5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4C5.28333 4 5.52083 4.09583 5.7125 4.2875C5.90417 4.47917 6 4.71667 6 5V14.5C6 16.3167 6.62917 17.8542 7.8875 19.1125C9.14583 20.3708 10.6833 21 12.5 21C14.3167 21 15.8542 20.3708 17.1125 19.1125C18.3708 17.8542 19 16.3167 19 14.5V11C18.7167 11 18.4792 11.0958 18.2875 11.2875C18.0958 11.4792 18 11.7167 18 12V16H15C14.45 16 13.9792 16.1958 13.5875 16.5875C13.1958 16.9792 13 17.45 13 18V19H11V18C11 16.9 11.3917 15.9583 12.175 15.175C12.9583 14.3917 13.9 14 15 14H16V4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3C17.2833 3 17.5208 3.09583 17.7125 3.2875C17.9042 3.47917 18 3.71667 18 4V9.175C18.1667 9.125 18.3292 9.08333 18.4875 9.05C18.6458 9.01667 18.8167 9 19 9H21V14.5C21 16.8667 20.175 18.875 18.525 20.525C16.875 22.175 14.8667 23 12.5 23Z"
          fill="currentColor"
        />
      </g>
    </Svg>
  );
}
export function IconReply(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4226"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4226)">
        <path
          d="M12.6667 12.6663V9.99967C12.6667 9.44412 12.4722 8.9719 12.0833 8.58301C11.6944 8.19412 11.2222 7.99967 10.6667 7.99967H4.55L6.95 10.3997L6 11.333L2 7.33301L6 3.33301L6.95 4.26634L4.55 6.66634H10.6667C11.5889 6.66634 12.375 6.99134 13.025 7.64134C13.675 8.29134 14 9.07745 14 9.99967V12.6663H12.6667Z"
          fill="#555555"
        />
      </g>

    </Svg>
  );
}
export function IconContentCopy(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4231"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4231)">
        <path
          d="M6 11.9997C5.63333 11.9997 5.31944 11.8691 5.05833 11.608C4.79722 11.3469 4.66667 11.033 4.66667 10.6663V2.66634C4.66667 2.29967 4.79722 1.98579 5.05833 1.72467C5.31944 1.46356 5.63333 1.33301 6 1.33301H12C12.3667 1.33301 12.6806 1.46356 12.9417 1.72467C13.2028 1.98579 13.3333 2.29967 13.3333 2.66634V10.6663C13.3333 11.033 13.2028 11.3469 12.9417 11.608C12.6806 11.8691 12.3667 11.9997 12 11.9997H6ZM6 10.6663H12V2.66634H6V10.6663ZM3.33333 14.6663C2.96667 14.6663 2.65278 14.5358 2.39167 14.2747C2.13056 14.0136 2 13.6997 2 13.333V3.99967H3.33333V13.333H10.6667V14.6663H3.33333Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconPencilEdit(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4236"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4236)">
        <path
          d="M1.33337 15.9997V13.333H14.6667V15.9997H1.33337ZM4.00004 10.6663H4.93337L10.1334 5.48301L9.18337 4.53301L4.00004 9.73301V10.6663ZM2.66671 11.9997V9.16634L10.1334 1.71634C10.2556 1.59412 10.3973 1.49967 10.5584 1.43301C10.7195 1.36634 10.8889 1.33301 11.0667 1.33301C11.2445 1.33301 11.4167 1.36634 11.5834 1.43301C11.75 1.49967 11.9 1.59967 12.0334 1.73301L12.95 2.66634C13.0834 2.78856 13.1806 2.93301 13.2417 3.09967C13.3028 3.26634 13.3334 3.43856 13.3334 3.61634C13.3334 3.78301 13.3028 3.9469 13.2417 4.10801C13.1806 4.26912 13.0834 4.41634 12.95 4.54967L5.50004 11.9997H2.66671Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconForward(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4241"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4241)">
        <path
          d="M3.99996 15.3337C3.63329 15.3337 3.3194 15.2031 3.05829 14.942C2.79718 14.6809 2.66663 14.367 2.66663 14.0003V6.66699C2.66663 6.30033 2.79718 5.98644 3.05829 5.72533C3.3194 5.46421 3.63329 5.33366 3.99996 5.33366H5.99996V6.66699H3.99996V14.0003H12V6.66699H9.99996V5.33366H12C12.3666 5.33366 12.6805 5.46421 12.9416 5.72533C13.2027 5.98644 13.3333 6.30033 13.3333 6.66699V14.0003C13.3333 14.367 13.2027 14.6809 12.9416 14.942C12.6805 15.2031 12.3666 15.3337 12 15.3337H3.99996ZM7.33329 10.667V3.21699L6.26663 4.28366L5.33329 3.33366L7.99996 0.666992L10.6666 3.33366L9.73329 4.28366L8.66663 3.21699V10.667H7.33329Z"
          fill="#555555"
        />
      </g>

    </Svg>
  );
}
export function IconDelete(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4247"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4247)">
        <path
          d="M4.66663 14C4.29996 14 3.98607 13.8694 3.72496 13.6083C3.46385 13.3472 3.33329 13.0333 3.33329 12.6667V4H2.66663V2.66667H5.99996V2H9.99996V2.66667H13.3333V4H12.6666V12.6667C12.6666 13.0333 12.5361 13.3472 12.275 13.6083C12.0138 13.8694 11.7 14 11.3333 14H4.66663ZM11.3333 4H4.66663V12.6667H11.3333V4ZM5.99996 11.3333H7.33329V5.33333H5.99996V11.3333ZM8.66663 11.3333H9.99996V5.33333H8.66663V11.3333Z"
          fill="#555555"
        />
      </g>

    </Svg>
  );
}
export function IconPlus(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask
        id="mask0_1070_4517"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1070_4517)">
        <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill="#555555" />
      </g>
    </Svg>
  );
}

export default Svg;
